import { useEffect, useRef } from 'react';

/**
 * Reference: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * by Dan Abramov
 */
const useInterval = (callback: () => void, delay: number) => {
  const savedCallback = useRef<() => void | undefined>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export default useInterval;
